import { useTranslation } from 'react-i18next';

import {
    Alert,
    Body1,
    Stack,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

export const PharmacyDoesNotCarryMedicationAlert = () => {
    const { t } = useTranslation();

    return (
        <Alert severity="warning">
            <Stack gap="xxs">
                <Subtitle2>
                    {t('offerPharmacyCard.pharmacyDoesNotCarry')}
                </Subtitle2>
                <Body1>
                    {t('previewDetails.pharmacyDoesNotCarry.description')}
                </Body1>
            </Stack>
        </Alert>
    );
};
